/*
 * Bouton du bandeau « Vente flash » : copie le code puis l'applique au panier, garde l'état
 * « Code appliqué » pour la session et trace l'issue. La fin de vente se lit sur le DOM
 * (`data-flash-end` et `html.flash-ended` sur <html>, boutons `disabled` posés par flash-sale-banner.js).
 */
(function () {
  if (window.__flashCodeBound) return;
  window.__flashCodeBound = true;

  var COPIED_VISIBLE_MS = 2500;
  var COPY_TIMEOUT_MS = 1500;
  var NETWORK_TIMEOUT_MS = 8000;
  var CONFIRM_MAX_AGE_MS = 30000;
  var STORAGE_PREFIX = 'mb-flash-applied-';

  var root = document.documentElement;
  var busy = false;
  var applied = false;
  var confirmedAt = 0;

  function returnTrue() {
    return true;
  }

  function returnFalse() {
    return false;
  }

  // Après le retrait du bandeau, `flash-ended` disparaît : la date de fin et `disabled` restent.
  function isSaleOver(button) {
    var end = Number(root.dataset.flashEnd) || 0;
    if (end && Date.now() / 1000 >= end) return true;
    return root.classList.contains('flash-ended') || !!(button && button.disabled);
  }

  function sameCode(a, b) {
    return String(a).toUpperCase() === String(b).toUpperCase();
  }

  // Panier vide : Shopify garde le code `applicable:false`, il sera évalué à l'ajout d'un article.
  function isAppliedIn(cart, code) {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (sameCode(codes[i].code, code)) return codes[i].applicable || cart.item_count === 0;
    }
    return false;
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    });
  }

  // L'envoi remplace tous les codes du panier : on réinjecte ceux qui s'appliquent déjà.
  function mergedCodes(cart, code) {
    var isEmpty = cart.item_count === 0;
    var kept = [];
    (cart.discount_codes || []).forEach(function (d) {
      if ((isEmpty || d.applicable) && !sameCode(d.code, code)) kept.push(d.code);
    });
    return kept.concat(code);
  }

  function applyCode(code) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var signal = controller ? controller.signal : undefined;
    var timeoutId = controller ? setTimeout(controller.abort.bind(controller), NETWORK_TIMEOUT_MS) : null;
    return fetchJson('/cart.js', { signal: signal })
      .then(function (cart) {
        return fetchJson('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: mergedCodes(cart, code).join(',') }),
          signal: signal,
        });
      })
      .then(function (cart) {
        return isAppliedIn(cart, code);
      })
      .catch(returnFalse)
      .finally(function () {
        clearTimeout(timeoutId);
      });
  }

  // Appelée de façon synchrone dans le handler : iOS refuse l'écriture après un `await`.
  function copyCode(code) {
    if (!window.isSecureContext || !navigator.clipboard || !navigator.clipboard.writeText) {
      return Promise.resolve(false);
    }
    var timeout = new Promise(function (resolve) {
      setTimeout(resolve, COPY_TIMEOUT_MS, false);
    });
    try {
      return Promise.race([navigator.clipboard.writeText(code).then(returnTrue, returnFalse), timeout]);
    } catch (e) {
      return Promise.resolve(false);
    }
  }

  function announce(banner, text) {
    var status = banner.querySelector('[data-flash-status]');
    if (status) status.textContent = text;
  }

  function setButtonsState(isApplied) {
    applied = isApplied;
    document.querySelectorAll('[data-flash-code-button]').forEach(function (button) {
      var defaultState = button.querySelector('[data-flash-code-default]');
      var appliedState = button.querySelector('[data-flash-code-applied]');
      if (defaultState) defaultState.hidden = isApplied;
      if (appliedState) appliedState.hidden = !isApplied;
    });
  }

  function showApplied() {
    setButtonsState(true);
  }

  function showDefault() {
    setButtonsState(false);
  }

  function rememberApplied(code, isApplied) {
    try {
      if (isApplied) sessionStorage.setItem(STORAGE_PREFIX + code.toUpperCase(), '1');
      else sessionStorage.removeItem(STORAGE_PREFIX + code.toUpperCase());
    } catch (e) {}
  }

  // Le nom accessible est figé pendant l'affichage : l'annonce passe par la zone aria-live.
  function showCopied(button, banner) {
    var label = banner.getAttribute('data-flash-copied-label');
    var defaultState = button.querySelector('[data-flash-code-default]');
    var codeText = button.querySelector('[data-flash-code-default] > span:not(.visually-hidden)');
    if (!label || !codeText) return Promise.resolve();
    var original = codeText.textContent;
    button.setAttribute('aria-label', defaultState.textContent.replace(/\s+/g, ' ').trim());
    codeText.textContent = label;
    announce(banner, label);
    return new Promise(function (resolve) {
      setTimeout(function () {
        codeText.textContent = original;
        button.removeAttribute('aria-label');
        resolve();
      }, COPIED_VISIBLE_MS);
    });
  }

  // Un échec du tracking ne doit pas interrompre le retour visuel déjà affiché.
  function trackOutcome(banner, name, code) {
    try {
      var location = banner.getAttribute('data-cta-location') || '';
      var payload =
        typeof window.mbStickyCtaPayload === 'function'
          ? window.mbStickyCtaPayload(name, location)
          : { cta_name: name, cta_location: location };
      payload.cta_placement = code;
      if (typeof window.trackEvent === 'function') {
        window.trackEvent('click_cta', payload);
        return;
      }
      window.dataLayer = window.dataLayer || [];
      payload.event = 'click_cta';
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  function handleOutcome(context, results) {
    var copied = results[0];
    if (results[1]) {
      showApplied();
      confirmedAt = Date.now();
      rememberApplied(context.code, true);
      announce(context.banner, context.appliedLabel);
      trackOutcome(context.banner, 'flash_code_applied', context.code);
      return Promise.resolve();
    }
    var feedback = copied ? showCopied(context.button, context.banner) : Promise.resolve();
    trackOutcome(context.banner, copied ? 'flash_code_copied' : 'flash_code_failed', context.code);
    return feedback;
  }

  function onClick(event) {
    var button = event.target.closest('[data-flash-code-button]');
    if (!button || isSaleOver(button)) return;
    var banner = button.closest('[data-flash-banner]');
    var code = banner && banner.getAttribute('data-flash-code');
    if (!code) return;
    var copying = copyCode(code);
    // Recopie seule, sans réseau ni event, tant que le panier vient de confirmer le code.
    if (busy || (applied && Date.now() - confirmedAt < CONFIRM_MAX_AGE_MS)) return;
    busy = true;
    button.setAttribute('aria-busy', 'true');
    var appliedState = button.querySelector('[data-flash-code-applied]');
    var context = {
      button: button,
      banner: banner,
      code: code,
      appliedLabel: appliedState ? appliedState.textContent.trim() : '',
    };
    Promise.all([copying, applyCode(code)])
      .then(function (results) {
        return handleOutcome(context, results);
      })
      .finally(function () {
        busy = false;
        button.removeAttribute('aria-busy');
      });
  }

  // Le drapeau de session ne suffit pas : le panier fait foi (anti-pattern n°27).
  function restoreAppliedState() {
    var banner = document.querySelector('[data-flash-banner]');
    var code = banner && banner.getAttribute('data-flash-code');
    if (!code || isSaleOver(document.querySelector('[data-flash-code-button]'))) return;
    var flagged = false;
    try {
      flagged = sessionStorage.getItem(STORAGE_PREFIX + code.toUpperCase()) === '1';
    } catch (e) {}
    if (!flagged) {
      if (applied) showDefault();
      return;
    }
    fetchJson('/cart.js')
      .then(function (cart) {
        var isApplied = isAppliedIn(cart, code);
        if (isApplied) confirmedAt = Date.now();
        setButtonsState(isApplied);
        if (!isApplied) rememberApplied(code, false);
      })
      .catch(function () {});
  }

  document.addEventListener('click', onClick);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) restoreAppliedState();
  });
  document.addEventListener('shopify:section:load', function () {
    applied = false;
    restoreAppliedState();
  });

  restoreAppliedState();
})();
